var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('spa-button',{staticClass:"mt-2 c-btn--w-large c-btn--h-middle c-btn--secondary c-btn--center",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }